// Environment variables type definitions

interface ImportMetaEnv {
  // API Configuration
  readonly VITE_API_BASE_URL: string
  
  // Authentication Configuration  
  readonly VITE_JWT_EXPIRATION_HOURS: string
  readonly VITE_TOKEN_REFRESH_THRESHOLD: string
  
  // PWA Push Notifications
  readonly VITE_VAPID_PUBLIC_KEY: string
  readonly VITE_VAPID_PRIVATE_KEY: string
  
  // Application Configuration
  readonly VITE_APP_NAME: string
  readonly VITE_APP_SHORT_NAME: string
  readonly VITE_APP_VERSION: string
  
  // Feature Flags
  readonly VITE_ENABLE_PWA: string
  readonly VITE_ENABLE_PUSH_NOTIFICATIONS: string
  readonly VITE_ENABLE_OFFLINE_MODE: string
  
  // Debug Settings
  readonly VITE_DEBUG_AUTH: string
  readonly VITE_DEBUG_API: string
  
  // Vite built-in
  readonly MODE: string
  readonly DEV: boolean
  readonly PROD: boolean
  readonly SSR: boolean
}

interface ImportMeta {
  readonly env: ImportMetaEnv
}

// Environment configuration helper
export interface AppConfig {
  api: {
    baseUrl: string
  }
  auth: {
    jwtExpirationHours: number
    tokenRefreshThreshold: number
  }
  pwa: {
    enabled: boolean
    vapidPublicKey: string
    vapidPrivateKey: string
  }
  app: {
    name: string
    shortName: string
    version: string
  }
  features: {
    pushNotifications: boolean
    offlineMode: boolean
  }
  debug: {
    auth: boolean
    api: boolean
  }
}

// Utility function to get typed config
export const getAppConfig = (): AppConfig => ({
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  },
  auth: {
    jwtExpirationHours: parseInt(import.meta.env.VITE_JWT_EXPIRATION_HOURS || '24'),
    tokenRefreshThreshold: parseInt(import.meta.env.VITE_TOKEN_REFRESH_THRESHOLD || '5'),
  },
  pwa: {
    enabled: import.meta.env.VITE_ENABLE_PWA === 'true',
    vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY,
    vapidPrivateKey: import.meta.env.VITE_VAPID_PRIVATE_KEY,
  },
  app: {
    name: import.meta.env.VITE_APP_NAME,
    shortName: import.meta.env.VITE_APP_SHORT_NAME,
    version: import.meta.env.VITE_APP_VERSION,
  },
  features: {
    pushNotifications: import.meta.env.VITE_ENABLE_PUSH_NOTIFICATIONS === 'true',
    offlineMode: import.meta.env.VITE_ENABLE_OFFLINE_MODE === 'true',
  },
  debug: {
    auth: import.meta.env.VITE_DEBUG_AUTH === 'true',
    api: import.meta.env.VITE_DEBUG_API === 'true',
  },
})